import { useReframe } from 'nike-re-framejs';
import React from 'react';
import clsx from 'clsx';
import FieldErrors from './fieldErrors';
import { NfSelect, selectOptions, makeField } from 'nike-form-js';

function SelectBox({ form, path, label, hint, emptyLabel, disabled = false, mandatory = false, options, children }) {
    const field = makeField(form, path);
    const { deref } = useReframe();
    const value = deref(field.getValue());
    const emptyItem = mandatory ? [['', emptyLabel, true]] : [['', emptyLabel]];
    const modOptions = !value && emptyLabel ? emptyItem.concat(options) : options;

    const isTouched = deref(field.isTouched());
    const errors = deref(field.getErrors());
    const isError = isTouched && errors.size > 0;
    const id = '' + path;

    return (
        <label
            data-path={path && path[0]}
            className={clsx('nike-input', {
                'nike-input-disabled': disabled
            })}
        >
            {label ? <div className="nike-input-label">{label}</div> : null}
            {hint ? <div className="nike-input-hint">{hint}</div> : null}
            <div className="nike-select">
                <NfSelect
                    field={field}
                    attrs={{
                        className: clsx({ error: isError }),
                        id,
                        disabled
                    }}
                >
                    {selectOptions(modOptions)}
                </NfSelect>
                <span className="select-arrow" />
                {children}
            </div>
            {isError ? <FieldErrors errors={errors} /> : null}
        </label>
    );
}

export default SelectBox;
